import classNames from "classnames";
import { Icon } from "@livingmap/hippo";

import styles from "./RichCTA.module.scss";

interface Props {
  dataQA: string;
  label?: string;
  icon?: {
    name: string;
    size: 18 | 24;
  };
  onClick?: (...args: any[]) => any;
  children?: React.ReactNode;
  disabled?: boolean;
}

const RichCTA: React.FC<Props> = ({
  dataQA,
  label,
  icon,
  onClick,
  children,
  disabled = false,
}) => {
  return (
    <div data-qa={dataQA}>
      {label && <span className={styles.label}>{label}</span>}
      <div
        className={classNames(styles.container, {
          [styles.disabled]: disabled,
        })}
        onClick={onClick}
      >
        {icon && (
          <Icon
            dataQA="cta-icon"
            {...icon}
            className={classNames(styles.icon)}
          />
        )}
        <div className={styles.contentWrapper}>{children}</div>
        <div className={styles.chevron}>
          <Icon dataQA="chevron-icon" name="chevron_right" size={24} />
        </div>
      </div>
    </div>
  );
};

export default RichCTA;
